import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { Input } from '../../../components/FormElements'

import styles from './loginComponents.module.scss'

interface FirstAndLastNamePropTypes {
  register?: (x: string, y: object) => object
  errors: Record<string, { message: string }>
  disabled?: boolean
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  containerClassName?: string
  errorClassName?: string
}

// @i18n-ignore
const INPUT_NAME = 'name'

const FirstAndLastName = ({
  register,
  errors,
  disabled,
  onChange,
  value,
  placeholder,
  containerClassName = '',
  errorClassName = '',
}: FirstAndLastNamePropTypes) => {
  const { t } = useTranslation('common')

  return (
    <div className={classNames(styles.container, containerClassName)}>
      <Input
        type="text"
        data-testid="first-and-last-name-input"
        placeholder={placeholder ?? t('name_and_last_name')}
        name={INPUT_NAME}
        required
        register={register}
        errors={errors}
        disabled={disabled}
        onChange={onChange}
        value={value}
        maxLength={100}
        errorClassName={errorClassName}
      />
    </div>
  )
}

export { FirstAndLastName }
